<template>
  <div>
    <a-card v-if="error === false" size="small" :loading="loading">
      <a-page-header :title="dataSource.title" :sub-title="`MRD详情 # MR-${dataSource.id}`">
        <a-descriptions size="small" :column="3">
          <a-descriptions-item label="创建人"> {{ dataSource.creator ? dataSource.creator.nickname : '--' }} </a-descriptions-item>
          <a-descriptions-item label="创建时间"> {{ dataSource.createdTime }} </a-descriptions-item>
          <a-descriptions-item label="更新时间"> {{ dataSource.updatedTime }} </a-descriptions-item>
        </a-descriptions>
      </a-page-header>
      <a-tabs v-model="active">
        <a-tab-pane :key="0" tab="详细信息" :force-render="true" />
        <a-tab-pane :key="1" :tab="`关联业务需求(${dataSource.businessRequirements.length})`" />
        <template v-if="false" slot="tabBarExtraContent">
          <a-button v-if="dataSource.businessRequirements.length === 0" type="primary" icon="plus" class="associate-button" @click="onAssociate">关联业务需求</a-button>
          <a-button v-else type="primary" @click="onDisassociate">解绑业务需求</a-button>
        </template>
      </a-tabs>
      <template v-if="loading === false">
        <fei-shu-document-new v-show="active === 0" :token="dataSource.token" :options="{ height: '70vh' }" @onTitleChange="onTitleChange" />
      </template>
      <span v-if="active === 1">
        <business-requirement-list :data-source="dataSource.businessRequirements" />
      </span>
    </a-card>
    <a-card v-else>
      <a-result status="403" title="403" sub-title="没有权限访问该文档">
        <template #extra>
          <a-button type="primary" @click="onBack"> 返回列表 </a-button>
        </template>
      </a-result>
    </a-card>
    <action-record-modal ref="actionRecordRef" />
    <associate-business-requirement ref="associateRef" @reload="getDoucmentData" />
  </div>
</template>
<script>
import { debounce } from 'lodash';
import { getDocument, updateDocument, disassociateDocument } from '@/api/business/document';

import FeiShuDocumentNew from '@/components/FeiShu/DocumentNew';
import ActionRecordModal from '@/pages/business/document/components/ActionRecordModal';
import BusinessRequirementList from '@/pages/business/document/components/BusinessRequirementList';
import AssociateBusinessRequirement from '@/pages/business/document/components/AssociateBusinessRequirement';

export default {
  components: { FeiShuDocumentNew, ActionRecordModal, BusinessRequirementList, AssociateBusinessRequirement },
  data() {
    return {
      active: 0,
      error: false,
      loading: true,
      dataSource: {
        title: null,
        status: 0
      },
      documentId: parseInt(this.$route.params.id) || null
    };
  },
  mounted() {
    this.getDoucmentData();
  },
  methods: {
    /**
     * 点击关联业务需求
     */
    onAssociate() {
      this.$nextTick(() => {
        this.$refs.associateRef.onOpen(this.documentId);
      });
    },

    /**
     * 修改文档标题
     * @param {*} title
     */
    onTitleChange: debounce(function (title) {
      if (title !== this.dataSource.title) {
        updateDocument({ id: this.documentId, title: title }).then(() => {
          this.getDoucmentData();
        });
      }
    }, 500),

    /**
     * 解绑业务需求
     */
    onDisassociate() {
      if (this.dataSource.businessRequirements.length === 0) {
        this.$message.success('未绑定MRD');
        return;
      } else {
        const self = this;
        this.$confirm({
          title: '确认',
          content: '确认要解除与该业务需求的关联关系吗?',
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          async onOk() {
            disassociateDocument({
              documentId: self.documentId,
              requirementId: self.dataSource.businessRequirements[0].id
            }).then(() => {
              self.$message.success('解除成功');
              self.getDoucmentData();
            });
          }
        });
      }
    },

    /**
     * 获取文档详情
     */
    getDoucmentData() {
      getDocument({ id: this.documentId })
        .then(res => {
          this.dataSource = res.data;
          this.loading = false;
        })
        .catch(res => {
          this.loading = false;
          if (res.code === 4003) {
            this.error = true;
          }
        });
    },
    onBack() {
      this.$router.push({ name: 'page:business:document' });
    }
  }
};
</script>

<style lang="less" scoped>
.ant-page-header {
  padding: 8px;
}
.associate-button {
  margin-bottom: 16px;
  float: right;
}
/deep/.ant-tabs-tab {
  margin-right: 4px;
}
</style>
